/* ==========================================================================
   TGGCore: Homepage interactions for the tgg-home-* sections.
   Idempotent: init() marks nodes with data-tgg-init so it can run on load
   and again on shopify:section:load without double-binding.
   ========================================================================== */
(function () {
  'use strict';

  function once(el) {
    if (el.hasAttribute('data-tgg-init')) return false;
    el.setAttribute('data-tgg-init', '');
    return true;
  }

  /* Best-sellers carousel + wishlist hearts */
  function initCarousels(root) {
    root.querySelectorAll('[data-bs-root]').forEach(function (sec) {
      if (!once(sec)) return;
      var track = sec.querySelector('[data-bs-track]');
      if (!track) return;
      var by = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); };
      var prev = sec.querySelector('[data-bs-prev]');
      var next = sec.querySelector('[data-bs-next]');
      if (prev) prev.addEventListener('click', function () { by(-1); });
      if (next) next.addEventListener('click', function () { by(1); });
      /* Progress scrollbar under the track (mobile): thumb width = visible share, position = scroll share */
      var bar = sec.querySelector('[data-bs-bar]');
      var thumb = bar ? bar.querySelector('[data-bs-thumb]') : null;
      if (thumb) {
        var paint = function () {
          var max = track.scrollWidth - track.clientWidth;
          var share = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          bar.hidden = max <= 1;
          thumb.style.width = (share * 100) + '%';
          thumb.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - share * 100) : 0) + '%';
        };
        track.addEventListener('scroll', paint, { passive: true });
        window.addEventListener('resize', paint);
        paint();
      }
      sec.querySelectorAll('.bs-card__heart').forEach(function (b) {
        b.addEventListener('click', function () {
          b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        });
      });
    });
  }

  /* FAQ accordion */
  function initFaq(root) {
    root.querySelectorAll('[data-faq]').forEach(function (faq) {
      if (!once(faq)) return;
      faq.addEventListener('click', function (e) {
        var q = e.target.closest('.faq__q');
        if (!q) return;
        var item = q.closest('.faq__item');
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* Delivery coverage: province cells carry data-name / data-info from blocks */
  function initCoverage(root) {
    root.querySelectorAll('[data-cov-root]').forEach(function (sec) {
      if (!once(sec)) return;
      var grid = sec.querySelector('[data-cov-grid]');
      var title = sec.querySelector('[data-cov-title]');
      var text = sec.querySelector('[data-cov-text]');
      if (!grid) return;
      grid.addEventListener('click', function (e) {
        var cell = e.target.closest('.cov__cell');
        if (!cell) return;
        grid.querySelectorAll('.cov__cell').forEach(function (c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        cell.classList.add('is-active');
        cell.setAttribute('aria-pressed', 'true');
        if (title && cell.dataset.name) title.textContent = cell.dataset.name;
        if (text && cell.dataset.info) text.textContent = cell.dataset.info;
      });
    });
  }

  /* Read more (mobile): toggles the CSS clamp; content is never removed from the DOM */
  function initReadMore(root) {
    var items = root.querySelectorAll('[data-readmore]');
    if (!items.length) return;
    var measure = function (box) {
      var clip = box.querySelector('.readmore__clip');
      if (!clip || box.classList.contains('is-open')) return;
      box.classList.remove('is-short');
      /* Short copy: nothing hidden, so no toggle */
      if (clip.scrollHeight <= clip.clientHeight + 8) box.classList.add('is-short');
    };
    items.forEach(function (box) {
      if (!once(box)) return;
      var btn = box.querySelector('[data-readmore-btn]');
      if (btn) {
        btn.addEventListener('click', function () {
          var open = box.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
          if (!open) box.scrollIntoView({ block: 'nearest' });
        });
      }
      measure(box);
    });
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { items.forEach(measure); }, 150);
    });
  }

  /* Trust band: open the chat widget when present; otherwise follow the fallback link */
  function initChatLinks(root) {
    root.querySelectorAll('[data-tgg-chat-open]').forEach(function (a) {
      if (!once(a)) return;
      a.addEventListener('click', function (e) {
        var tidio = window.tidioChatApi;
        if (tidio && typeof tidio.open === 'function') {
          e.preventDefault();
          tidio.show && tidio.show();
          tidio.open();
        }
      });
    });
  }

  /* Finder mobile band: a tapped chip answers step 1 of the on-page quiz in
     place (reveal the quiz, click the matching real chip). The link's href
     (finder page with ?recipient=) stays as the no-JS fallback. */
  function initFinderBand(root) {
    root.querySelectorAll('.finder-band').forEach(function (band) {
      if (!once(band)) return;
      band.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-band-chip]');
        if (!chip) return;
        var section = band.closest('.finder');
        var quizChip = section && section.querySelector('[data-gf-opt="recipient"][data-gf-value="' + chip.getAttribute('data-band-chip') + '"]');
        if (!quizChip) return; /* fall through to the finder page */
        e.preventDefault();
        section.classList.add('is-engaged');
        quizChip.click();
        var card = section.querySelector('.finder__card');
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init(root) {
    initFinderBand(root);
    initChatLinks(root);
    initCarousels(root);
    initFaq(root);
    initCoverage(root);
    initReadMore(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
